import Services from './base-services'

const service = new Services('bookUserNotes')

export default {
    getAllNotesByUserAndBook(userId: any, bookId: any) {
        return service.post(`getAllNotesByUserAndBook?userId=${userId}&bookId=${bookId}`)
    },
    createNote(data: any) {
        return service.post(`createNote`, data)
    },
    deleteNote(noteId: any) {
        return service.delete(`deleteNote?noteId=${noteId}`)
    },
}
